import { mapGetters } from 'vuex'
import siteTab from '@/components/tab'
export default {
  components: {
    siteTab
  },
  data() {
    return {
      menus: [
        {
          name: 'General',
          href: '/system/dictpublisher-setting/email-setting',
          code: 'SYSTEM.PUBLISHER_SETTING.GENERAL'
        },
        {
          name: 'Option',
          href: '/system/dictpublisher-setting/general-setting',
          code: 'SYSTEM.PUBLISHER_SETTING.OPTION_SETTING'
        },
        {
          name: 'Country',
          href: '/system/dictpublisher-setting/country-setting',
          code: 'SYSTEM.PUBLISHER_SETTING.COUNTRY_SETTING'
        },
        {
          name: 'Article Type',
          href: '/system/dictpublisher-setting/article-type-setting',
          code: 'SYSTEM.PUBLISHER_SETTING.ARTICLE_TYPE_SETTING'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage'
    })
  },
  watch: {
    user: {
      handler() {
        this.redict()
      },
      immediate: true
    },
    $route() {
      this.redict()
    }
  },
  mounted() {},
  methods: {
    redict() {
      if (this.$route.path !== '/system/dictpublisher-setting') {
        return
      }
      this.menus.some(item => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.$router.replace(item.href)
          return true
        }
      })
    }
  }
}
